import React from "react";
import "./NextStockTitleMark.css";

/** Transparent, animated vector adaptation of the Next Stock corner-frame mark. */
export default function NextStockTitleMark({ className = "" }) {
  return (
    <svg className={`next-stock-title-mark ${className}`} viewBox="0 0 64 64" width="36" height="36" role="img" aria-label="Next Stock" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" strokeWidth="3.5" strokeLinejoin="miter">
        <path className="ns-mark-red" d="M4 5 H53 V12 H60 V60" />
        <path className="ns-mark-blue" d="M4 5 V54 H11 V60 H60" />
      </g>
      <g className="ns-mark-letters" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="12.5" letterSpacing="1.5" textAnchor="middle">
        <text className="ns-mark-next" x="33" y="22">NEX</text>
        <text className="ns-mark-mixed" x="33" y="38"><tspan className="ns-mark-blue-letter">T</tspan><tspan className="ns-mark-red-letter">ST</tspan></text>
        <text className="ns-mark-stock" x="33" y="52">OCK</text>
      </g>
    </svg>
  );
}
